import { render, staticRenderFns } from "./MyButtonBoolean.vue?vue&type=template&id=52474e19&scoped=true&"
import script from "./MyButtonBoolean.vue?vue&type=script&lang=js&"
export * from "./MyButtonBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52474e19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52474e19')) {
      api.createRecord('52474e19', component.options)
    } else {
      api.reload('52474e19', component.options)
    }
    module.hot.accept("./MyButtonBoolean.vue?vue&type=template&id=52474e19&scoped=true&", function () {
      api.rerender('52474e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyButtonBoolean.vue"
export default component.exports